import { render, staticRenderFns } from "./ToggleFormItem.vue?vue&type=template&id=dca59f3c&"
import script from "./ToggleFormItem.vue?vue&type=script&lang=js&"
export * from "./ToggleFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports